import React from "react";

const CheckboxInput = ({
	options,
	error,
	label,
	required,
	register,
	id,
	validate,
}) => {
	return (
		<div className="form-field checkboxes-field">
			{label && (
				<label className="field-label">
					{label}
					{required && <span className="required">*</span>}
				</label>
			)}

			<div className="checkbox-options">
				{options.map((option) => (
					<div className="form-check" key={option.value}>
						<input
							type="checkbox"
							value={option.value}
							{...register(id, {
								required: required ? "Please select an option" : false,
								validate: validate,
							})}
							id={`${id}-${option.value}`}
							className={error ? "error" : ""}
						/>
						<label
							className="form-check-label"
							htmlFor={`${name}-${option.value}`}
						>
							<div dangerouslySetInnerHTML={{ __html: option.label }} />
						</label>
					</div>
				))}
			</div>

			{error && <div className="field__error">{error.message}</div>}
		</div>
	);
};

export default CheckboxInput;
